// main.js 修改如下
import { createApp } from 'vue'
import App from './App.vue'
import Bmob from 'hydrogen-js-sdk'

// 全局错误处理 - 简化版本，避免循环
window.addEventListener('error', function(e) {
  const target = e.target;
  
  // 处理图片SSL错误
  if (target.tagName === 'IMG' && target.src.includes('file.tradesoeasy.xyz')) {
    console.warn('图片SSL错误，尝试使用HTTP:', target.src);
    
    // 尝试将HTTPS转为HTTP
    try {
      const newSrc = target.src.replace('https:', 'http:');
      
      // 防止循环设置
      if (target.src !== newSrc) {
        target.src = newSrc;
      }
    } catch (error) {
      console.error('处理图片错误失败:', error);
    }
  }
}, true);

// 初始化 Bmob SDK
try {
  // 请确保这里的 Application ID 和 REST API Key 正确
  Bmob.initialize("6928a056fa87cb20", "1234567890123456")
  console.log("Bmob SDK 初始化成功")
} catch (error) {
  console.error("Bmob SDK 初始化失败:", error)
}

// 创建Vue应用
const app = createApp(App)

// 挂载Bmob到全局
app.config.globalProperties.$bmob = Bmob

// 添加全局的Bmob对象到window，方便在控制台调试
window.Bmob = Bmob

// 挂载应用
app.mount('#app')